import * as fromDatatype from '../datatype-library/index';

export interface bl_hc_medicine_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  medicine_name: fromDatatype.VarcharDatatypeInterface;
  medicine_code: fromDatatype.VarcharDatatypeInterface;
  generic_name: fromDatatype.VarcharDatatypeInterface;
  brand_name: fromDatatype.VarcharDatatypeInterface;
  dosage: fromDatatype.VarcharDatatypeInterface;
  form: fromDatatype.VarcharDatatypeInterface;
  route_of_administration: fromDatatype.VarcharDatatypeInterface;
  indications: fromDatatype.VarcharDatatypeInterface;
  contraindications: fromDatatype.VarcharDatatypeInterface;
  warnings: fromDatatype.VarcharDatatypeInterface;
  precautions: fromDatatype.VarcharDatatypeInterface;
  interactions: fromDatatype.VarcharDatatypeInterface;
  overdose: fromDatatype.VarcharDatatypeInterface;
  storage: fromDatatype.VarcharDatatypeInterface;
  disposal: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_hc_medicine_hdr_RowClass implements bl_hc_medicine_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  medicine_name: fromDatatype.VarcharDatatypeInterface;
  medicine_code: fromDatatype.VarcharDatatypeInterface;
  generic_name: fromDatatype.VarcharDatatypeInterface;
  brand_name: fromDatatype.VarcharDatatypeInterface;
  dosage: fromDatatype.VarcharDatatypeInterface;
  form: fromDatatype.VarcharDatatypeInterface;
  route_of_administration: fromDatatype.VarcharDatatypeInterface;
  indications: fromDatatype.VarcharDatatypeInterface;
  contraindications: fromDatatype.VarcharDatatypeInterface;
  warnings: fromDatatype.VarcharDatatypeInterface;
  precautions: fromDatatype.VarcharDatatypeInterface;
  interactions: fromDatatype.VarcharDatatypeInterface;
  overdose: fromDatatype.VarcharDatatypeInterface;
  storage: fromDatatype.VarcharDatatypeInterface;
  disposal: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}